// extracted by mini-css-extract-plugin
export var infoItem = "_td-2";
export var title = "_td-0";
export var value = "_td-1";